module.exports = __webpack_public_path__ + "assets/0b250e4f154342d36e0079238525365a.png";